import React, { useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import logoFaceMessenger from 'images/icons/face-messenger.svg';
import style from './style.scss'; //NOSONAR

const SocialSharing = (props) => {
    
    const {product} = props;
    const {info} = props;
    const [sharing, setSharing] = useState({});

    const settings = {
        facebook: true,
        messenger: true,
        twitter: true,
        whatsapp: true,
        mail: true
    };

    useEffect(() => {
        if(props.settings){
            Object.assign(settings, props.settings);
        }
        
        if(info) {
            setSharing({
                title: encodeURI(`${info.title}`),
                url: encodeURI(info.url)
            });
        }

        if(product) {
            setSharing({
                title: encodeURI(`${product.productName} | Jumbo.cl - Jumbo`),
                url: `${window.location.origin}/${product.linkText}/p`
            });
        }
    }, [info, product]);

    const clickWhatsapp = () => {
        if(window && (window.innerWidth <= 768)) {
            
            window.location.href = `whatsapp://send?text=${sharing.url}`;
        
        } else {

            window.location.href = `https://wa.me/?text=${sharing.url}`;
        }
    }

    const fbURL = `https://www.facebook.com/sharer.php?s=100&p[title]=${sharing.title}&p[url]=${sharing.url}&u=${sharing.url}&t=${sharing.title}`;
    const twURL = `https://twitter.com/intent/tweet?url=${sharing.url}`;
    const msnFbURL = `fb-messenger://share/?link=${sharing.url}`;

    return (
        <div className="social-wrapper">
            <ul className="social-list">
                {settings.facebook && <li className="social-list-item"><a className="social-list-link social-list-facebook  font-icn facebook" target="_blank" rel="noopener noreferrer" href={fbURL}></a></li>}
                {settings.messenger && <li className="social-list-item social-list-item-msn"><a className="social-list-link social-list-messenger font-icn face-messenger" dangerouslySetInnerHTML={{__html: logoFaceMessenger }} target="_blank" rel="noopener noreferrer" href={msnFbURL} ></a></li>}
                {settings.twitter && <li className="social-list-item"><a className="social-list-link social-list-twitter font-icn twitter" target="_blank" rel="noopener noreferrer" href={twURL}></a></li>}
                {settings.whatsapp && <li className="social-list-item"><button className="social-list-link social-list-whatsapp  font-icn whatsapp" onClick={()=>clickWhatsapp()} data-action="share/whatsapp/share"/></li>}
                {settings.mail && <li className="social-list-item"><a className="social-list-link social-list-email  font-icn email" href={`mailto:?subject=${sharing.title}&body=${sharing.title}`}></a></li>}
            </ul>
        </div>
    )
}

SocialSharing.propTypes = {
    settings: PropTypes.object,
    product: PropTypes.object,
    info:PropTypes.object,
}

export default SocialSharing;
